/**
 * This file is generated from scripts/genIconComponents.js. Any
 * changes should be made in that file.
 */
import React, { forwardRef, Ref } from "react";
import { getSvgResourceForSize, getDefaultSize } from "../../utils";
import { Icon, LodestarIconProps } from "../../icon";
import { SvgKebab as KebabMedium } from "./medium/Kebab";
import { SvgKebab as KebabXxSmall } from "./xxSmall/Kebab";
const sizeMap = {
    medium: KebabMedium,
    xxSmall: KebabXxSmall,
};
const defaultSize = getDefaultSize(sizeMap);

export const KebabIcon = forwardRef(
    (
        { size = defaultSize, ...rest }: LodestarIconProps,
        ref: Ref<HTMLElement>
    ) => (
        <Icon
            ref={ref}
            svgComponent={getSvgResourceForSize(sizeMap, size)}
            size={size}
            {...rest}
        />
    )
);
KebabIcon.displayName = "KebabIcon";
